import { FC } from 'react';
import { roleLevelOptions } from '../../../../constants/roleLevel';
import {
  TFormFieldValue,
  TMultiSelectFormFieldValue,
} from '../../../../interfaces/forms/form';
import MultiselectFormField from '../MultiselectFormField';

export interface IRoleLevelFilterMultiselectFormField {
  id: string;
  name: string;
  value: TMultiSelectFormFieldValue;
  label: string;
  onChange: (value: TFormFieldValue, name: string) => void;
  onBlur?: (value: string, name: string) => void;
  hasError?: boolean;
  errorText?: string;
}

const RoleLevelFilterMultiselectFormField: FC<IRoleLevelFilterMultiselectFormField> = props => {
  return (
    <MultiselectFormField
      {...props}
      inputProps={{
        'data-role': 'soft-skill-filter-select',
      }}
      options={roleLevelOptions}
    />
  );
};

export default RoleLevelFilterMultiselectFormField;
